<div
  id="kebabMenu"
  class="dropdown ahe-ui-dropdown dropdown-menu-right"
  [ngClass]="showKebab ? 'open' : ''"
>
  <button
    #kebabButton
    app-button
    appTooltip="Options"
    [parent]="parentContainer"
    [alternateAriaLabel]="alternateAriaLabel ? alternateAriaLabel : (this.collection?.collection_title ? `Options for ${this.collection?.collection_title}` : 'Options')"
    type="button"
    class="btn btn-icon btn-secondary"
    data-toggle="dropdown"
    [ngClass]="showKebab ? 'active' : ''"
    aria-haspopup="menu"
    [attr.aria-expanded]="showKebab"
    tabindex="0"
    (click)="pinUnpinCheck()"
    aria-controls="kebabMenuList"
  >
    <i
      class="ahe-icon ahe-icon-system-kebab"
    ></i>
  </button>
  <ul
    id="kebabMenuList"
    role="menu"
    [ngClass]="
      (showKebab && lastKebab
        ? 'show-kebab last-kebab dropdown-menu dropdown-menu-right'
        : showKebab
        ? 'show-kebab dropdown-menu dropdown-menu-right'
        : 'hide-kebab') +
      (showKebabAbove ? ' show-kebab-above' : '')
    "
  >
    <!-- <div class="kebab-menu-height list-items-container"> -->
    <li role="none">
      <a
        id="kebab-item"
        *ngIf="kebabMenu.get_info"
        class="dropdown-item"
        role="menuitem"
        aria-haspopup="dialog"
        tabindex="-1"
        data-dismiss="modal"
        (click)="viewAssessment(true)"
        (keydown)="handleMenuKeyboard($event, 'viewAssessment')"
      >
        Get Info
      </a>
    </li>
    <li role="none">
      <a
        id="kebab-item-add-new-part"
        *ngIf="kebabMenu.addNewPart"
        class="dropdown-item"
        role="menuitem"
        tabindex="-1"
        aria-haspopup="menu"
        [attr.aria-expanded]="showQuestionTypes"
        aria-controls="question-types-submenu"
        (click)="showNewQuestion($event)"
        (keydown)="handleMenuKeyboard($event, 'showNewQuestion')"
      >
        Add new part <span style="float: right" aria-hidden="true">></span>
      </a>
      <ul
        id="question-types-submenu"
        class="dropdown-menu question-types-dropdown-menu"
        role="menu"
        [ngClass]="showQuestionTypes ? 'show-list' : 'hide-list'"
        [attr.aria-hidden]="!showQuestionTypes"
      >
        <li role="none" *ngFor="let type of questionTypesList;  let i = index">
          <a
            [id]="'submenu-item-' + i"
            class="dropdown-item"
            role="menuitem"
            tabindex="-1"
            data-dismiss="modal"
            (click)="createNewQuestion(type, $event)"
            (keydown)="handleMenuKeyboard($event, 'createNewQuestion', type)"
          >
            {{ type.viewValue }}
            <span class="sr-only">, opens in new tab</span>
          </a>
        </li>
      </ul>
    </li>
    <li role="none">
      <a
        id="kebab-item-unpin"
        *ngIf="kebabMenu.pinUnpin && pinFlag"
        class="dropdown-item"
        role="menuitem"
        tabindex="-1"
        (click)="pinUnpinQuestionEvent($event)"
        (keydown)="handleMenuKeyboard($event, 'pinUnpinQuestionEvent', $event)"
      >
        Unpin
      </a>
    </li>
    <li role="none">
      <a
        id="kebab-item-pin"
        *ngIf="kebabMenu.pinUnpin && unPinFlag"
        class="dropdown-item"
        role="menuitem"
        tabindex="-1"
        (click)="pinUnpinQuestionEvent($event)"
        (keydown)="handleMenuKeyboard($event, 'pinUnpinQuestionEvent', $event)"
      >
        Pin
      </a>
    </li>
    <li role="none">
      <a
        id="kebab-item-edit"
        *ngIf="kebabMenu.edit"
        class="dropdown-item"
        role="menuitem"
        tabindex="-1"
        (click)="editAssessment()"
        (keydown)="handleMenuKeyboard($event, 'editAssessment')"
      >
        Edit
      </a>
    </li>
    <li role="none">
      <a
        id="kebab-item-copy"
        *ngIf="kebabMenu.copy"
        class="dropdown-item"
        role="menuitem"
        aria-haspopup="dialog"
        tabindex="-1"
        (click)="copyTest()"
        (keydown)="handleMenuKeyboard($event, 'copyTest')"
      >
        Copy
      </a>
    </li>
    <li role="none">
      <!-- Export the test -->
      <a
        id="kebab-item-export"
        *ngIf="kebabMenu.export"
        class="dropdown-item"
        role="menuitem"
        tabindex="-1"
        (click)="exportTest()"
        (keydown)="handleMenuKeyboard($event, 'exportTest')"
      >
        Export and Share Test
      </a>
    </li>
    <li role="none">
      <a
        id="kebab-item-rename"
        *ngIf="kebabMenu.rename"
        class="dropdown-item"
        role="menuitem"
        aria-haspopup="dialog"
        tabindex="-1"
        (click)="renameModal($event)"
        (keydown)="handleMenuKeyboard($event, 'renameModal')"
      >
        Rename
      </a>
    </li>
    <li role="none">
      <a
        id="kebab-item-edit-question"
        *ngIf="kebabMenu.editQuestion"
        class="dropdown-item"
        role="menuitem"
        tabindex="-1"
        (click)="editQuestion($event)"
        (keydown)="handleMenuKeyboard($event, 'editQuestion', $event)"
        [attr.aria-haspopup]="isEditableInNewTab ? null : 'dialog'"
      >
        Edit item
        <span class="sr-only" *ngIf="isEditableInNewTab"> opens in new tab</span>
      </a>
    </li>
    <li role="none">
      <a
        id="kebab-item-copy-edit"
        *ngIf="kebabMenu.copyAndEdit && collection.userEdited == true"
        class="dropdown-item"
        role="menuitem"
        tabindex="-1"
        (click)="editCopy($event)"
        (keydown)="handleMenuKeyboard($event, 'editCopy', $event)"
      >
        Make a copy and edit
        <span class="sr-only">Opens in a new tab</span>
      </a>
    </li>
    <li role="none">
      <a
        id="kebab-item-usage"
        *ngIf="kebabMenu.pastUsage"
        class="dropdown-item"
        role="menuitem"
        aria-haspopup="dialog"
        tabindex="-1"
        (click)="questionUses($event)"
        (keydown)="handleMenuKeyboard($event, 'questionUses', $event)"
      >
        Where have I used this question?
      </a>
    </li>
    <li role="none">
      <a
        id="kebab-item-print"
        *ngIf="kebabMenu.print"
        class="dropdown-item"
        role="menuitem"
        tabindex="-1"
        href="#"
      >
        Print
      </a>
    </li>
    <li role="none">
      <a
        id="kebab-item-remove"
        *ngIf="kebabMenu.remove"
        class="dropdown-item"
        role="menuitem"
        tabindex="-1"
        [attr.aria-haspopup]="(kebabMenu.addNewPart || (!kebabMenu.pinUnpin && isLastPartQuestion)) ? 'dialog' : null"
        data-dismiss="modal"
        (click)="deleteAssessment(true)"
        (keydown)="handleMenuKeyboard($event, 'deleteAssessment', undefined, false, false)"
      >
        Remove
      </a>
    </li>
    <li role="none">
      <a
        id="kebab-item-delete"
        *ngIf="kebabMenu.delete"
        class="dropdown-item"
        role="menuitem"
        tabindex="-1"
        aria-haspopup="dialog"
        data-dismiss="modal"
        (click)="deleteAssessment(true)"
        (keydown)="handleMenuKeyboard($event, 'deleteAssessment')"
      >
        Delete
      </a>
    </li>
    <li role="none"
      *ngIf="kebabMenu.moveUp"
      [ngClass]="firstKebab ? 'disabled' : ''">
      <a
        id="kebab-item-moveup"
        [attr.aria-disabled]="firstKebab"
        class="dropdown-item"
        role="menuitem"
        tabindex="-1"
        (click)="handleMoveUp($event)"
        (keydown)="handleMoveUp($event)"
      >
        Move Up
      </a>
    </li>
    <li role="none" 
      *ngIf="kebabMenu.moveDown"
      [ngClass]="lastKebab ? 'disabled' : ''">
      <a
        id="kebab-item-movedown"
        [attr.aria-disabled]="lastKebab"
        class="dropdown-item"
        role="menuitem"
        tabindex="-1"
        (click)="handleMoveDown($event)"
        (keydown)="handleMoveDown($event)"
      >
        Move Down
      </a>
    </li>
    <li role="none"
      *ngIf="kebabMenu.moveToTestPanel">
      <a
        id="kebab-item-movetotestpanel"
        class="dropdown-item"
        role="menuitem"
        tabindex="-1"
        (click)="moveToTestPanel()"
        (keydown)="handleMenuKeyboard($event, 'moveToTestPanel')"
      >
        Move to Test Panel
      </a>
    </li>
    <li role="none"
      *ngIf="kebabMenu.updatePointsModal">
      <a
        id="kebab-item-updatePointsModal"
        class="dropdown-item"
        role="menuitem"
        tabindex="-1"
        (click)="updatePointsModal()"
        (keydown)="handleMenuKeyboard($event, 'updatePointsModal')"
        aria-haspopup="dialog"
      >
        Update Points
      </a>
    </li>
    <li role="none"
      *ngIf="kebabMenu.removeQuestionsModal">
      <a
        id="kebab-item-removeQuestionsModal"
        class="dropdown-item"
        role="menuitem"
        tabindex="-1"
        (click)="removeQuestionsModal()"
        (keydown)="handleMenuKeyboard($event, 'removeQuestionsModal')"
        [attr.aria-haspopup]="showRemoveModal ? 'dialog' : null"
      >
        Remove
      </a>
    </li>

    <!-- </div> -->
  </ul>
</div>

<app-shared-modal
  *ngIf="rename"
  titleText="Rename"
  [isOpen]="rename"
  confirmButtonText="Confirm"
  cancelButtonText="Cancel"
  (close)="modalCancelJob()"
  (cancel)="modalCancelJob()"
  (confirm)="modalOkJob()"
>
  <form [formGroup]="renameValidationForm" assessmentName>
    <div class="ahe-ui form-group">
      <label for="name" class="float-left">Title</label>
      <div class="input-container">
      <input
        #TitleNameInput
        id="name"
        class="form-control"
        formControlName="title"
        (input)="clearFilter()"
        [ngClass]="{ 'is-invalid': submitted && renameValidationForm.invalid && message !== '' }"
        [attr.aria-invalid]="submitted && renameValidationForm.invalid ? 'true' : 'false'"
        [attr.aria-describedby]="submitted && message !== '' ? 'message' : null"
      />
      </div>
      <div
        *ngIf="submitted && renameValidationForm.controls.title.errors"
        class="invalid-feedback"
      >
        <div
          class="float-left"
          *ngIf="renameValidationForm.controls.title.errors.required"
        ></div>
      </div>
      <div
        *ngIf="
          submitted &&
          renameValidationForm.controls.title.errors &&
          renameValidationForm.controls.title.errors.minlength
        "
        class="invalid-feedback"
      >
        <div
          class="float-left"
          *ngIf="
            renameValidationForm.controls.title.errors.minlength
              .requiredLength >
            renameValidationForm.controls.title.errors.minlength.actualLength
          "
        ></div>
      </div>
      <div
        *ngIf="
          submitted &&
          renameValidationForm.controls.title.errors &&
          renameValidationForm.controls.title.errors.maxlength
        "
        class="invalid-feedback"
      >
        <div
          class="float-left"
          *ngIf="
            renameValidationForm.controls.title.errors.maxlength.actualLength >
            renameValidationForm.controls.title.errors.maxlength.requiredLength
          "
        ></div>
      </div>
      <div
        *ngIf="submitted && renameValidationForm.errors"
        class="invalid-feedback"
      >
        <div
          class="float-left"
          *ngIf="renameValidationForm.errors.validated"
        ></div>
      </div>
      <div *ngIf="submitted && message !== ''" class="error-container">
        <i aria-hidden="true" class="fa fa-exclamation-circle fa-fw error-info-icon mt-1 mr-1"></i>
      <div
        [id]="'message'"
        class="unique-error"
      >
        <span class="sr-only">Error: </span>
        <span [innerHtml]="message"></span>
      </div>
      </div>
    </div>
  </form>
</app-shared-modal>

<div
  *ngIf="showDelete != false"
  class="ahe-ui-alert-modal"
  id="okCancelModal"
  role="dialog"
  tabindex="-1"
  aria-labelledby="deleteTitle"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  (keydown.escape)="checkTooltipPresent() ? null : closeModal(false)"
>
  <div class="modal-overlay">
    <div class="modal-container-new">
      <div class="modal-dialog-more-info-new">
        <div class="modal-content">
          <div class="modal-header-new">
            <h2 id="deleteTitle" class="modal-title">Delete Test</h2>
            <button
              app-button
              appTooltip="Close"
              class="close"
              data-dismiss="modal"
              type="button"
              (click)="closeModal(false)"
            >
              <span
                aria-hidden="true"
                class="ahe-icon ahe-icon-close-white"
              ></span>
            </button>
          </div>
          <div class="modal-body-new">
            <div class="container-fluid pl-0">
              <p>You are about to delete this test. This cannot be undone.</p>
              <p>Are you sure you want to delete this test?</p>
            </div>
          </div>
          <div class="modal-footer-new">
            <app-button
              buttonText="Cancel"
              [purpose]="_buttonPurpose.Secondary"
              class="align-left"
              data-dismiss="modal"
              (click)="closeModal(false)"
            ></app-button>
            <app-button
              buttonText="Yes"
              [purpose]="_buttonPurpose.Primary"
              data-dismiss="modal"
              (click)="closeModal(true)"
            ></app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="show != false"
  class="ahe-ui-alert-modal"
  id="viewMore"
  role="dialog"
  tabindex="-1"
  aria-labelledby="moreInfoTitle"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  (keydown.escape)="checkTooltipPresent() ? null : viewAssessment(false)"
>
  <div class="modal-overlay">
    <div class="modal-container-new">
      <div class="modal-dialog-more-info-new">
        <div class="modal-content">
          <div class="modal-header-new">
            <h2 id="moreInfoTitle" class="modal-title">More info</h2>
            <button
              app-button
              appTooltip="Close"
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
              (click)="viewAssessment(false)"
            >
              <span
                aria-hidden="true"
                class="ahe-icon ahe-icon-close-white"
              ></span>
            </button>
          </div>
          <div class="modal-body-new">
            <ng-container *ngIf="viewAssessmentData">
              <dl *ngIf="viewAssessmentData.isbnTitle && viewAssessmentData.isbnTitle !== ''" class="book-information-inline-list">
              <div class="assessment-info-item">
                <dt>Title:</dt>
                <dd>{{ viewAssessmentData.isbnTitle }}</dd>
              </div>
              <div class="assessment-info-item">
                <dt>Author:</dt>
                <dd>{{ viewAssessmentData.isbnAuthor }}</dd>
              </div>
              <div class="assessment-info-item">
                <dt>Edition:</dt>
                <dd>{{ viewAssessmentData.isbnEdition }}</dd>
              </div>
              </dl>

              <dl class="inline-list">
              <div class="assessment-info-item">
                <dt>Test Name:</dt>
                <dd>{{ viewAssessmentData.collection_title }}</dd>
              </div>
              <div class="assessment-info-item">
                <dt>Date Created:</dt>
                <dd>{{ viewAssessmentData.creation | date: 'MMM d, y, h:mm:ss a' }}</dd>
              </div>
              <div class="assessment-info-item">
                <dt>Date Last Modified:</dt>
                <dd>{{ viewAssessmentData.modified | date: 'MMM d, y, h:mm:ss a' }}</dd>
              </div>
              </dl>

              <div class="line-divider" aria-hidden="true"></div>

              <dl class="inline-list">
              <ng-container *ngFor="let assessment of viewAssessmentData.questionsType | keyvalue">
                <div class="assessment-info-item">
                <dt *ngIf="assessment.key == 'Algo_count'">Algorithm:</dt>
                <dt *ngIf="assessment.key == 'MC_count'">Multiple Choice:</dt>
                <dt *ngIf="assessment.key == 'TF_count'">True False:</dt>
                <dt *ngIf="assessment.key == 'FB_count'">Fill in the Blank:</dt>
                <dt *ngIf="assessment.key == 'CA_count'">Check all that apply:</dt>
                <dt *ngIf="assessment.key == 'SA_count'">Short Answers:</dt>
                <dt *ngIf="assessment.key == 'ES_count'">Essay:</dt>
                <dt *ngIf="assessment.key == 'SB_count'">Section Break:</dt>
                <dd>{{ assessment.value }}</dd>
                </div>
              </ng-container>
              </dl>
            </ng-container>
          </div>
          <div class="modal-footer-new">
            <app-button
              class="align-left"
              buttonText="OK"
              [purpose]="_buttonPurpose.Primary"
              data-dismiss="modal"
              (click)="viewAssessment(false)"
            ></app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="showIframe"
  class="ahe-ui-alert-modal"
  id="previewModal"
  role="dialog"
  tabindex="-1"
  aria-labelledby="previewTitle"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  (keydown.escape)="checkTooltipPresent() ? null : closePreviewModal(true)"
>
  <div class="modal-overlay" id="previewModalOverlay">
    <div class="modal-container-new">
      <div class="modal-dialog-more-info-new">
        <div class="modal-content preview-content" style="margin-left: -98px">
          <div class="modal-header-new">
            <h2 id="previewTitle" class="modal-title">Preview</h2>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
              (click)="closePreviewModal(true)"
            >
              <span class="ahe-icon ahe-icon-close-white"></span>
            </button>
          </div>
          <div class="modal-body-new" *ngFor="let item of previewCheckedArr">
            <div class="question-body">
              <div class="question-sequence">
                <div class="ml-3" style="padding-top: 6px">
                  <strong>Question {{ item.index + 1 }}</strong>
                </div>
              </div>
              <div class="ml-4 mt-2" style="font-size: 18px">
                <span
                  ><strong>{{ item.typeDesc }}</strong></span
                >
              </div>
              <div class="ml-4 mt-2">
                <iframe
                  [src]="
                    sanitizer.bypassSecurityTrustResourceUrl(item.onlinePreview)
                  "
                  class="iframe-body-multiple preview-body"
                  id="previewIframe"
                ></iframe>
              </div>
            </div>
            <div
              class="row h-20 justify-content-center align-items-center button-align"
            >
              <app-pager
                [length]="totalPage"
                [pageIndex]="pageNumber"
                [pageSize]="itemsPerPage"
                (page)="pageChanged($event)"
              ></app-pager>
            </div>
          </div>

          <div class="modal-footer-new">
            <app-button
              buttonText="Ok"
              [purpose]="_buttonPurpose.Primary"
              data-dismiss="modal"
              (click)="closePreviewModal(true)"
            ></app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-shared-modal
  *ngIf="showCopyModal"
  titleText="Copy Test"
  [isOpen]="showCopyModal"
  confirmButtonText="OK"
  cancelButtonText="Cancel"
  (close)="cancelCopy()"
  (cancel)="cancelCopy()"
  (confirm)="confirmCopy()"
>
  <div class="modal-body-copy ahe-ui form-group">
    <div class="container-fluid pl-0 title-text">
      <p>You are about to make a copy of this test.</p>
    </div>
    <div class="row">
      <label class="title-div" for="newCollectionTitle">Title:</label>
      <div id="copyContainer" class="md-9 ml-sm-2 col-sm-auto pl-sm-0">
        <app-input
          [id]="'newCollectionTitle'"
          [type]="inputType.Text"
          [error]="showCopyError"
          [(ngModel)]="newCollectionTitle"
          (keyup)="hideErrorsDebounced()"
          [maxlength]="80"
          [ariaDescribedBy]="showCopyError ? 'copy-error-message' : null"
          [showFeedback]="false"
        ></app-input>
      </div>
    </div>
    <div *ngIf="showCopyError" class="error-container">
      <i aria-hidden="true" class="fa fa-exclamation-circle fa-fw error-info-icon mt-1 mr-1"></i>
      <div
        id="copy-error-message"
        class="md-9 ml-1 copy-error-message"
      >
        <span class="sr-only">Error: </span>
        <span [innerHTML]="copyErrorMsg"></span>
      </div>
    </div>
  </div>
</app-shared-modal>

<!-- #make-edit-copy modal start  -->
<div
  *ngIf="showEditAlert"
  class="ahe-ui-alert-modal"
  id="editModal"
  role="dialog"
  tabindex="-1"
  aria-labelledby="editQuestionTitle"
  cdkTrapFocus
  cdkTrapFocusAutoCapture
  aria-modal="true"
  (keydown.escape)="checkTooltipPresent() ? null : closeEditModal()"
>
  <div class="modal-overlay">
    <div class="modal-container-new">
      <div class="modal-dialog-more-info-new">
        <div class="modal-content">
          <div class="modal-header-new">
            <h2 id="editQuestionTitle" class="modal-title">Edit Question</h2>
            <button
              app-button
              appTooltip="Close"
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
              (click)="closeEditModal(true)"
            >
              <span class="ahe-icon ahe-icon-close-white"></span>
            </button>
          </div>
          <div class="modal-body-new">
            <div *ngIf="this.confirmBtn">
              By editing a question from a McGraw Hill test bank you will be creating a copy of the question. Questions you create or modify are not maintained by McGraw Hill, and their content will not be affected by future content updates and releases. 
              <br />
              <br />
              You can access the current version of this question again later by adding it from the question source. 
            </div>

            <div *ngIf="this.confirmBtn == false">
              By editing this question, changes will affect all tests that
              contain this question. To make edits that only apply to this test,
              make a copy first and then edit.
              <br />
              <br />
              To see where this question has been used, select the "Where have I
              used this question" link in the menu to the right of the question
              title.
              <br />
              <br />
              How would you like to proceed?
            </div>
          </div>
          <div class="modal-footer-new">
            <app-button
              *ngIf="this.confirmBtn"
              buttonText="Yes, continue to edit"
              [purpose]="_buttonPurpose.Primary"
              data-dismiss="modal"
              (click)="continueEditCopyModal(false)"
            >
              <span class="sr-only">Opens in a new tab</span>
            </app-button>
            <app-button
              *ngIf="this.confirmBtn"
              buttonText="No, cancel edit"
              [purpose]="_buttonPurpose.Secondary"
              class="align-left"
              data-dismiss="modal"
              (click)="closeEditModal(false)"
            ></app-button>
            <app-button
              *ngIf="this.confirmBtn == false"
              class="apply-edit"
              buttonText="Apply edits to all tests"
              [purpose]="_buttonPurpose.Primary"
              data-dismiss="modal"
              (click)="continueEditModal(false)"
            ></app-button>
            <app-button
              *ngIf="this.confirmBtn == false"
              buttonText="Make a copy and edit"
              [purpose]="_buttonPurpose.Primary"
              data-dismiss="modal"
              (click)="editCopy(false)"
              style="padding-left: 25px"
            ></app-button>
            <app-button
              *ngIf="this.confirmBtn == false"
              buttonText="Cancel"
              [purpose]="_buttonPurpose.Secondary"
              class="align-left"
              data-dismiss="modal"
              (click)="closeEditModal(false)"
              style="padding-left: 40px"
            ></app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--   -->
<!-- #make-edit-copy modal end  -->

<!-- #where-I-Have-Used modal end  -->

<div
  *ngIf="whereIHaveUsedframe"
  class="ahe-ui-alert-modal"
  id="whereIHaveUsedframe"
  role="dialog"
  tabindex="-1"
  aria-labelledby="questionUsedModalTitle"
  cdkTrapFocus
  cdkTrapFocusAutoCapture
  aria-modal="true"
  (keydown.escape)="checkTooltipPresent() ? null : closeQuestionUsedModal()"
>
  <div class="modal-overlay" id="whereIHaveUsedframeModalOverlay">
    <div class="modal-container-new">
      <div class="modal-dialog-more-info-new">
        <div class="modal-content">
          <div class="modal-header-new">
            <h2 id="questionUsedModalTitle" class="modal-title">Where I have used this question?</h2>
            <button
              app-button
              appTooltip="Close"
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
              (click)="closeQuestionUsedModal(true)"
            >
              <span class="ahe-icon ahe-icon-close-white"></span>
            </button>
          </div>
          <div class="modal-body-new">
            <div class="">
              <div class="row1 bodyRow" style="height: 90%">
                <div class="modal-header-message">
                  <h3
                    class="header-span"
                    *ngIf="
                      questionUsedArr.consumers.length > 0 &&
                      questionUsedArr.consumers.length == 1
                    "
                    >This question was used in the following assignment</h3
                  >
                  <h3
                    class="header-span"
                    *ngIf="questionUsedArr.consumers.length > 1"
                    >This question was also used in the following
                    {{ questionUsedArr.consumers.length }} assignments</h3
                  >
                  <h3
                    class="header-span"
                    *ngIf="questionUsedArr.consumers.length == 0"
                    >This question was not used in any other assignments</h3
                  >
                </div>
                <div *ngIf="questionUsedArr.consumers.length > 0">
                  <div class="row no-margin assignment-list-container">
                    <ul class="dpg-ui-list assignment-list"
                      [ngClass]="
                        questionUsedArr.consumers.length > 5
                          ? 'whr-hav-used-tbl'
                          : ' whr-hav-used-tbl-no-height'
                      "
                      [attr.tabindex]="questionUsedArr.consumers.length > 5 ? '0' : null"
                      role="list"
                    >
                      <li *ngFor="let qitem of questionUsedArr.consumers" class="question-list assignment-list-item" role="listitem">
                        <div class="row">
                            <span class="whr-hav-used-tbl-txt">{{
                              qitem.collection_title
                              }}</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer-new">
            <app-button
              buttonText="OK"
              [purpose]="_buttonPurpose.Secondary"
              class="align-left"
              data-dismiss="modal"
              (click)="closeQuestionUsedModal(false)"
            ></app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
